import { create } from "zustand";

interface ActionBarState {
  active: boolean;
  setActive: (active: boolean) => void;
}

export const useActionBarState = create<ActionBarState>((set) => ({
  active: false,
  setActive: (active) => set({ active }),
}));
